import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { LocalAuthService } from '../services/auth.service';

// Bewusst synchron: Auth0s isAuthenticated$ emittiert erst, wenn der SDK den Redirect-Callback
// (Token-Austausch) abgeschlossen hat. Wartet der Guard darauf, rendert der Router währenddessen
// gar nichts – der Nutzer sieht nach der Rückkehr von Auth0 nur eine leere Seite und der Loader
// der Callback-Seite wird nie sichtbar. Die Seite selbst wartet auf den Auth-Zustand und leitet
// anschließend weiter.
export const callbackGuard: CanActivateFn = (route): boolean | UrlTree => {
  const authService = inject(LocalAuthService);
  const router = inject(Router);

  const hasAuthQuery =
    (route.queryParamMap.has('code') && route.queryParamMap.has('state')) ||
    route.queryParamMap.has('error');

  if (!hasAuthQuery || !authService.hasPendingCallback()) {
    authService.clearPendingCallback();
    return router.createUrlTree(['/home']);
  }

  return true;
};
